import {
  Amex,
  ApplePay,
  Mastercard,
  PayPal,
  ShopPay,
  Visa,
} from '../components/vectors';

export const paymentMethods = [
  {
    id: '2a2e617b-9b3b-4461-a7cf-458689701f61',
    icon: ApplePay,
  },
  {
    id: '575f0bb5-c3ff-45f9-98e5-48f3b33e722e',
    icon: Visa,
  },
  {
    id: 'b2c629e2-82f3-4655-b4e8-5dcfd580ff9e',
    icon: Mastercard,
  },
  {
    id: 'dd64bcb8-97cc-4631-8426-16eecd346c1f',
    icon: Amex,
  },
  {
    id: 'eeb02d44-9cf4-4842-9274-357e1df33d54',
    icon: PayPal,
  },
  {
    id: '97791c1e-1808-4b91-ae03-27c01f43c406',
    icon: ShopPay,
  },
];
